import React from 'react';
import { TeamPermission, usePlansAdminService } from 'nekst-api';
import { AccessChecker } from 'authorization-scope';
import { ViewPlanAsAdmin } from '../../../../plans/view/ViewPlan';
import { useParams } from 'react-router-dom';
import { useSetupAreaVersionContextRequired } from '../SetupAreaVersionContext';
import ChoosePlanDropdownWidget from '../../../../plans/List/ChoosePlanDropdownWidget';
import { Button, ButtonColor, ButtonSize, IconType } from 'ui-builder';
import { usePopupFormManager } from 'features/nekst-widgets';
import { CreatePlanForm } from './CreatePlanForm';
import PlanFilterContainer from '../../../../plans/tasks/List/Filter/PlanFilterContainer';
import MainBlock from '../../../../shared/web/layout/MainBlock';
import MarketsBreadcrumbs from '../MarketsBreadcrumbs';
import { useStateContext } from '../StateContext';
import useSettingsNavigator from '../../../settingsNavigator';
import { useSetupAreaRequiredButtonsHelper } from '../../../markets/setupAreaRequiredHelper';

function CreatePlanButton(props: {
  setupAreaId: number,
  setupAreaVersion: string,
}) {

  const popupFormManager = usePopupFormManager();

  const { isDisabled: isButtonDisabled, title: buttonTitle } = useSetupAreaRequiredButtonsHelper();

  return (
    <Button
      text="Create new workflow"
      onClick={() => {
        popupFormManager.openForm((
          <CreatePlanForm
            setupAreaId={props.setupAreaId}
            setupAreaVersion={props.setupAreaVersion}
          />
        ));
      }}
      size={ButtonSize.BIG}
      isFilled
      color={ButtonColor.BLUE}
      iconType={IconType.PLUS}
      isDisabled={isButtonDisabled}
      title={buttonTitle  }
    />
  );
}


function ChoosePlanDropdown(props: {
  value?: number,
  marketId: number
  setUpAreaId: number,
  version: string
}) {
  const plansAdminService = usePlansAdminService();

  const stateContext = useStateContext();

  const settingsNavigator = useSettingsNavigator();

  return (
    <ChoosePlanDropdownWidget
      getPlansFunc={async () => plansAdminService.getPlans(
        props.setUpAreaId,
        props.version
      )}
      openListPage={() => {
        settingsNavigator.openAdminSetupAreaPlansPage(
          stateContext.id,
          props.setUpAreaId,
          props.version
        );
      }}
      openPlanPage={(planId: number) => {
        settingsNavigator.openAdminMarketPlanPage(
          stateContext.id,
          props.setUpAreaId,
          props.version,
          planId
        );
      }}
      value={props.value}
    />
  );
}

function WorkflowsBreadcrumbs() {
  return (
    <MarketsBreadcrumbs text="Workflows" />
  );
}


export default function PlansList() {

  const params = useParams();

  const isPlanPage = params.id !== undefined;

  const columnContent = isPlanPage ? <PlanFilterContainer /> : null;

  const { setupArea, setupAreaVersion } = useSetupAreaVersionContextRequired();

  return (
    <AccessChecker permissionToCheck={TeamPermission.READ_PLANS}>
      <MainBlock
        title={`${setupArea.name}: Workflows`}
        headerRight={<CreatePlanButton key="create" setupAreaId={setupArea.id} setupAreaVersion={setupAreaVersion.version} />}
        columnContent={columnContent}
      >
        <div
          className="form dark"
          style={{
            minHeight: '500px',
          }}
        >
          <div style={{ width: '80%' }}>
            <ChoosePlanDropdown
              value={(params.id && parseInt(params.id, 10)) || undefined}
              marketId={setupArea.id}
              setUpAreaId={setupArea.id}
              version={setupAreaVersion.version}
            />
            <WorkflowsBreadcrumbs />
          </div>

          <div style={{ marginTop: '40px' }}>
            {params.id !== undefined && (
              <ViewPlanAsAdmin
                id={parseInt(params.id, 10)}
                setupAreaId={setupArea.id}
                setupAreaVersion={setupAreaVersion.version}
              />
            )}
          </div>
        </div>
      </MainBlock>
    </AccessChecker>
  );
}
